// The guest's sign-in gate (ChatShell): a guest sees the user app's menu
// (shell/nav.ts guestNav), and a row opens this dialog instead of the page.
// The guest stays on the chat; the Google choices (shell/GoogleSignIn) carry
// ?next= so signing in opens the page that was clicked (a new account goes
// through onboarding first, with the same next).
import type { NavItem } from "./nav";
import { GoogleButton } from "./GoogleSignIn";
import { Dialog } from "../ui/components";

export function SignInGateDialog({ item, onClose }: { item: NavItem | null; onClose: () => void }) {
  return (
    <Dialog
      open={item !== null}
      size="sm"
      title={item ? `Masuk untuk membuka ${item.label}` : "Masuk"}
      description="Menu ini tersedia setelah Anda masuk dengan Google. Setelah masuk, halaman ini langsung terbuka."
      onClose={onClose}
    >
      <div className="cs-gate">{item ? <GoogleButton block next={item.href} /> : null}</div>
    </Dialog>
  );
}
